import { Card } from 'antd5';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  background: ${({ theme }) => theme.secondaryBackgroundColor} !important;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: unset;

  .ant-card-head {
    background: ${({ theme }) => theme.tertiaryBackgroundColor} !important;
    border-bottom: 2px solid ${({ theme }) => theme.borderColor};
    border-radius: unset;
    border-width: 1px;
    color: ${({ theme }) => theme.headerColor};

    .ant-card-head-wrapper {
      align-items: center;
    }

    .ant-card-head-title {
      font-weight: normal;
    }

    .ant-card-extra {
      color: ${({ theme }) => theme.headerColor};
    }

    .ant-tabs {
      color: ${({ theme }) => theme.headerColor};

      .ant-tabs-tab-disabled {
        color: ${({ theme }) => theme.disabledTextColor};
      }

      .ant-tabs-nav::before {
        border-color: ${({ theme }) => theme.borderColor};
      }
    }
  }

  .ant-card-body {
    border-radius: unset;

    color: ${({ theme }) => theme.textColor};
  }

  .ant-card-actions {
    background: ${({ theme }) => theme.secondaryBackgroundColor} !important;
    span {
      color: ${({ theme }) => theme.secondaryTextColor} !important;
    }
  }

  .ant-card-meta-title {
    font-weight: normal;
    color: ${({ theme }) => theme.headerColor};
  }
  .ant-card-meta-description {
    color: ${({ theme }) => theme.secondaryTextColor} !important;
  }
`;
